/**
 * 微信环境检测工具函数
 * 用于检测微信浏览器环境和相关功能支持
 */

/**
 * 检测是否在微信浏览器中
 * @returns {boolean}
 */
export function isWechatBrowser() {
  return /MicroMessenger/i.test(navigator.userAgent)
}

/**
 * 检测是否支持微信支付
 * @returns {boolean}
 */
export function supportWechatPay() {
  return typeof WeixinJSBridge !== 'undefined'
}

/**
 * 等待微信JSBridge准备就绪
 * @returns {Promise<void>}
 */
export function waitForWeixinJSBridge() {
  return new Promise((resolve) => {
    if (typeof WeixinJSBridge !== 'undefined') {
      resolve()
    } else {
      document.addEventListener('WeixinJSBridgeReady', resolve, false)
    }
  })
}

/**
 * 初始化微信环境
 * @returns {Object} 环境信息
 */
export function initWechatEnvironment() {
  const isWechat = isWechatBrowser()
  
  if (isWechat) {
    document.documentElement.setAttribute('data-wechat', 'true')
  }
  
  return {
    isWechatBrowser: isWechat,
    supportWechatPay: supportWechatPay(),
    userAgent: navigator.userAgent
  }
}